module.exports = __webpack_public_path__ + "static/img/6.56a273ff.png";